
import React from "react";
import "./InfoItem.css"

interface InfoItemProps {
    title: string;
    dotcolor: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ title, dotcolor }) => {
    return (
        <div className="info-item">
            <div className="info-item-dot" style={{backgroundColor: dotcolor}}/>
            <div className="info-item-text">{title}</div>
        </div>
    );
}

export default InfoItem;
